import { ExclamationTriangleIcon } from "@heroicons/react/16/solid";
import { Tooltip } from "./Tooltip";

export function IncompleteScheduleWarning({ scheduledContacts, plannedContacts }) {
  return (
    <div className="mt-1 flex items-start justify-center gap-1 text-xs text-amber-700 whitespace-normal">
      <ExclamationTriangleIcon className="h-4 w-4 shrink-0" />
      <span>
        Only {scheduledContacts} of {plannedContacts} planned recipients
        scheduled
      </span>
      <Tooltip
        size="4"
        iconClassName="shrink-0"
        content={
          <div className="text-sm text-gray-900 whitespace-normal">
            The scheduling was interrupted before all recipients were added.
            Cancel this campaign and schedule it again.
          </div>
        }
      />
    </div>
  );
}
